import { gatewayPageBuilder } from "../../../../gateways/gatewayPageBuilder";

export type SiteLatestResponse = {
    status: number;
    data: {
        id: string;
        slug: string;
        projectName: string;
        templateId: string;
        thumbnailUrl?: string | null;
        latestVersionId?: string | null;
        isPublished: boolean;
        createdAt: string;
        updatedAt: string;
        latestVersion: null | {
            id: string;
            siteId: string;
            version: number;
            content: { html: string; css: string };
            documentHtml: string;
            s3Key?: string | null;
            publicUrl?: string | null;
            contentHash?: string | null;
            createdAt: string;
            updatedAt: string;
        };
    };
};

export const getSiteById = async (siteId: string): Promise<SiteLatestResponse["data"]> => {
    const token = sessionStorage.getItem("token");
    if (!token) throw new Error("No auth token found");
    if (!siteId) throw new Error("Missing siteId");

    const { data } = await gatewayPageBuilder.get<SiteLatestResponse>(
        `page-builder/sites/self/${siteId}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        }
    );

    return data.data;
};
